import { render, staticRenderFns } from "./PlatformProgress.vue?vue&type=template&id=4b0af1ee"
import script from "./PlatformProgress.vue?vue&type=script&lang=js"
export * from "./PlatformProgress.vue?vue&type=script&lang=js"
import style0 from "./PlatformProgress.vue?vue&type=style&index=0&id=4b0af1ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports